"use strict";
/**
 * Created by Marvin on 26.04.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var modalActions_1 = require("../actions/modalActions");
var ModalBody_1 = __importDefault(require("./ModalBody"));
var ModalCloseButton_1 = __importDefault(require("./ModalCloseButton"));
var Modal = function (_a) {
    var showModal = _a.showModal, children = _a.children, hide = _a.hide, modalClass = _a.modalClass, _b = _a.modalName, modalName = _b === void 0 ? 'modal' : _b, _c = _a.modalSize, modalSize = _c === void 0 ? 'md' : _c, _d = _a.plain, plain = _d === void 0 ? false : _d, _e = _a.hideable, hideable = _e === void 0 ? true : _e;
    return (react_1["default"].createElement("div", null,
        (showModal === modalName ?
            (react_1["default"].createElement("div", { className: "modal-backdrop in", onClick: hideable ? hide : null }))
            : null),
        react_1["default"].createElement("div", { className: 'modal fade' +
                (showModal === modalName ? ' in' : '') +
                (modalClass ? ' ' + modalClass : '') },
            react_1["default"].createElement("div", { onClick: hideable ? hide : null, style: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' } }),
            react_1["default"].createElement("div", { className: 'modal-dialog modal-' + modalSize, role: "document" },
                react_1["default"].createElement("div", { className: "modal-content" }, plain ?
                    (react_1["default"].createElement("div", null, children)) :
                    (react_1["default"].createElement(ModalBody_1["default"], null,
                        hideable ? (react_1["default"].createElement(ModalCloseButton_1["default"], null)) : null,
                        children)))))));
};
var mapStateToProps = function (state) {
    return ({
        showModal: state.modal.showModal || null
    });
};
var mapDispatchToProps = function (dispatch) { return ({
    hide: function () { return dispatch((0, modalActions_1.hideModal)()); }
}); };
exports["default"] = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(Modal);
